import $ from 'jquery';
// import ScrollMagic from 'scrollmagic';
// import LocomotiveScroll from 'locomotive-scroll';
// import '../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
// import paroller from 'paroller.js'; // eslint-disable-line

// $(window).on('load', function () {
(() => {



  const totalSeq = 145;
  const imgChangeSpeed = 40;

  var loadMV = false;
  var tmp = {};
  for(var i=100; i<=totalSeq; i++){
    const _i = i;
    const img = new Image();
    tmp[_i] = null;
    img.src = "./share/images/seq/mv_seq_"+_i+".jpg"; // 連続するファイル名
    img.addEventListener("load",()=>{
        tmp[_i] = img;
        // console.log(_i);
    })
  }

  // new LocomotiveScroll({
  //   el: document.querySelector('[data-scroll-container]'),
  //   // smooth: false,
  //   smooth: true,
  // });


  // return false;

  // new LocomotiveScroll();

  // var controller1 = new ScrollMagic.Controller();
  // var scene1 = new ScrollMagic.Scene({
  //   triggerElement: '.trigger',
  //   duration: 500,
  // }).setPin('.trigger').addTo(controller1);

  // var scroll = document.getElementById('scroll');
  // let scrollWrite = () => {
  //   var windowScroll = window.scrollY;
  //   scroll.innerText = windowScroll;
  // };
  // window.addEventListener('scroll',scrollWrite);
  var controller = new ScrollMagic.Controller();

  // new ScrollMagic.Scene({triggerElement: ".lineup", offset: 300})
  //   .setPin(".lineup")
  //   .addTo(controller);


  new ScrollMagic.Scene({
    duration: 1300,//終了距離
    reverse: true,
  })
    .setPin('.mv')
    // .addIndicators({ name: 'sticky!' }) // デバッグ用インジケータの表示
    .addTo(controller);

  new ScrollMagic.Scene({
    offset: 300,
    reverse: true,
  })
    // .setClassToggle('.mv1', 'zoom')
    .on('enter', function (e) {





      var t = setInterval(loadImg, imgChangeSpeed);
      var s = 100;
      function loadImg(){
        // console.log("load" + s);
        s++;
        if(s >= totalSeq){
          clearInterval(t);
          $('.mv2').addClass('fade');
        }
        $(".mv1").css("background-image","url(./share/images/seq/mv_seq_"+s+".jpg)")
      }


      // $('.mv1').addClass('zoom');
      // setTimeout(function(){$('.mv1').addClass('none')},700);
      // setTimeout(function(){$('.mv2').addClass('fade')},700);
      // $('.mv2').addClass('fade')
    })
    .on('leave', function (e) {
      // $('.mv1').removeClass('zoom');
      // $('.mv1').removeClass('none');


      var t = setInterval(loadImg, imgChangeSpeed);
      var s = totalSeq;
      function loadImg(){
        // console.log("load" + s);
        s--;
        // $('.mv2').removeClass('fade');
        $(".mv1").css("background-image","url(./share/images/seq/mv_seq_"+s+".jpg)")
        if(s == 100){
          clearInterval(t);
        }
      }



      $('.mv2').removeClass('fade');
    })
    .addTo(controller);



  // new ScrollMagic.Scene({
  //   offset: 200,
  //   reverse: true,
  // })
  //   .on('enter', function (e) {
  //     // $('.mv1').addClass('zoom');

  //     $('.mv1').animate({

  //         transform: 'translateX(-16%) translateY(-140%) scale(20)'

  //     });
  //   })
  //   .on('leave', function (e) {
  //     $('.mv1').removeClass('zoom');
  //   })
  //   .addTo(controller);

// var tween = TweenMax.fromTo(".mv1", 0.5, {opacity:0} , {opacity: 1});
//   new ScrollMagic.Scene({
//     offset: 200,
//   })
//   .setTween(tween) // trigger a TweenMax.to tween
//   .addTo(controller);


  // new ScrollMagic.Scene({
  //   offset: 1000,
  //   reverse: true,
  // })
  //   .setClassToggle('.mv1', 'none')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 1000,
  //   reverse: true,
  // })
  //   .setClassToggle('.mv2', 'fade')
  //   .addTo(controller);

  new ScrollMagic.Scene({
    offset: 700,
    reverse: true,
  })
    .setClassToggle('.mv__text1', 'wipe')
    .addTo(controller);

  new ScrollMagic.Scene({
    offset: 900,
    reverse: true,
  })
    .setClassToggle('.mv__text2Inner', 'wipe')
    .addTo(controller);

  new ScrollMagic.Scene({
    offset: 1100,
    reverse: true,
  })
    .setClassToggle('.mv__text2022', 'wipe')
    .addTo(controller);

  // new ScrollMagic.Scene({
  //   duration: 1400,
  //   triggerHook: 'onLeave',
  //   // reverse: true,
  // })
  //   .setPin('.lineup__filter--fixed')
  //   .addTo(controller);

  // sm--anim

  $('.sm--anim').each(function (i, node) {
    new ScrollMagic.Scene({
      offset: 100,
      triggerHook: 'onEnter',
      triggerElement: node,
      reverse: true,
    })
      .setClassToggle(node, 'anim')
      .addTo(controller);
  });


    new ScrollMagic.Scene({
      offset: 0,
      triggerHook: 'onLeave',
      triggerElement: '.shindan',
      reverse: true,
    })
    .setClassToggle('body', 'contents')
    .addTo(controller);


    let interview1Scroll = new ScrollMagic.Scene({
      offset: 0,
      triggerHook: 'onEnter',
      triggerElement: '.interview1__btm',
      reverse: true,
    })
    .setClassToggle('body', 'contents')
    .addTo(controller);

    interview1Scroll.on("enter",function(){

      // console.log("interview1Scroll");
      let _move = $(".interview1__btmImg--scroll").width() - $(window).width();
      // $(".interview1__btmImg").scrollLeft(_move);
      $(".interview1__btmImg").delay(2000).animate({scrollLeft:_move}, { duration: 1500, easing: 'swing', });
    })
    

  // var controllerLineUp = new ScrollMagic.Controller();
  // new ScrollMagic.Scene({
  //   triggerElement: '.js-lineup__product',
  //   triggerHook: 'onLeave',
  //   duration: $('.js-lineup__product').height(),
  //   // offset: 800,
  //   reverse: true,
  // })
  //   // .setPin('.js-lineup__product')
  //   .addTo(controller)
  //   // .addTo(controllerLineUp)
  //   // .on('update', function (e) {
  //   //   console.log('??????');
  //   // })
  //   .on('progress', function (e) {
  //     // console.log('progress');
  //   });
  //   ;






  /*
    ラインのパララクス
   */
  $(window).scroll(
    function () {

      var l1 = $('.interview1__line1');
      var elemTop1 = Math.floor(l1.offset().top);
      var elemH1 = Math.floor(l1.height());
      var l2 = $('.interview1__line2');
      var elemTop2 = Math.floor(l2.offset().top);
      var elemH2 = Math.floor(l2.height());
      var l3 = $('.interview1__line3');
      var elemTop3 = Math.floor(l3.offset().top);
      var elemH3 = Math.floor(l3.height());
      var l2_1 = $('.interview2__line1');
      var elemTop2_1 = Math.floor(l2_1.offset().top);
      var elemH2_1 = Math.floor(l2_1.height());
      var l3_1 = $('.interview3__line1');
      var elemTop3_1 = Math.floor(l3_1.offset().top);
      var elemH3_1 = Math.floor(l3_1.height());
      var l4_1 = $('.interview4__line1');
      var elemTop4_1 = Math.floor(l4_1.offset().top);
      var elemH4_1 = Math.floor(l4_1.height());
      var ido = 300;
      var wh = Math.floor($(window).height());
      var scrollPos = Math.floor($(window).scrollTop() + wh);

      if (scrollPos > elemTop1 && scrollPos < elemTop1 + elemH1 + wh) {
        l1.css({
          transform: 'translate(0, -'+ ~~(ido * (scrollPos - elemTop1) / (elemH1+wh)) +'px)',// eslint-disable-line
        });
      } else if (scrollPos > elemTop2 && scrollPos < elemTop2 + elemH2 + wh) {
        l2.css({
          transform: 'translate(0, -'+ ~~(ido * (scrollPos - elemTop2) / (elemH2+wh)) +'px)',// eslint-disable-line
        });
      } else if (scrollPos > elemTop3 && scrollPos < elemTop3 + elemH3 + wh) {
        l3.css({
          transform: 'translate(0, -'+ ~~(ido * (scrollPos - elemTop3) / (elemH3+wh)) +'px)',// eslint-disable-line
        });
      } else if (scrollPos > elemTop2_1 && scrollPos < elemTop2_1 + elemH2_1 + wh) {
        l2_1.css({
          transform: 'translate(0, -'+ ~~(ido * (scrollPos - elemTop2_1) / (elemH2_1+wh)) +'px)',// eslint-disable-line
        });
      } else if (scrollPos > elemTop3_1 && scrollPos < elemTop3_1 + elemH3_1 + wh) {
        l3_1.css({
          transform: 'translate(0, -'+ ~~(ido * (scrollPos - elemTop3_1) / (elemH3_1+wh)) +'px)',// eslint-disable-line
        });
      } else if (scrollPos > elemTop4_1 && scrollPos < elemTop4_1 + elemH4_1 + wh) {
        l4_1.css({
          transform: 'translate(0, -'+ ~~(ido * (scrollPos - elemTop4_1) / (elemH4_1+wh)) +'px)',// eslint-disable-line
        });
      }
      // else this.target.removeClass('header--open');
    }.bind(this),
  );



  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.mainCopy',
  //   reverse: true,
  // })
  //   .setClassToggle('.mainCopy', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.profile__left',
  //   reverse: true,
  // })
  //   .setClassToggle('.profile__left', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.profile__right',
  //   reverse: true,
  // })
  //   .setClassToggle('.profile__right', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview1__photo1',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview1__photo1', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview1__photo2',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview1__photo2', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview1__grid',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview1__grid', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview1__btm',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview1__btm', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview2',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview2', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview3',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview3', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview4__col',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview4__col', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview4__photo3',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview4__photo3', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview5__photo1',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview5__photo1', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview5__photo2',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview5__photo2', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.interview5__colRight',
  //   reverse: true,
  // })
  //   .setClassToggle('.interview5__colRight', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.fitting',
  //   reverse: true,
  // })
  //   .setClassToggle('.fitting', 'anim')
  //   .addTo(controller);

  // new ScrollMagic.Scene({
  //   offset: 100,
  //   triggerHook: 'onEnter',
  //   triggerElement: '.shindan',
  //   reverse: true,
  // })
  //   .setClassToggle('.shindan', 'anim')
  //   .addTo(controller);





})();
// });
